import React from "react";
import { Progress } from "antd";
import "./style.scss";
import LevelTag from "components/LevelTag";
interface LevelProgressBarProps {
  type: "worker" | "process";
  level: number;
  percentToBoostLevel: number;
  style?: React.CSSProperties;
}

const LevelProgressBar: React.FC<LevelProgressBarProps> = ({
  type,
  level,
  percentToBoostLevel,
  style = {},
}) => {
  const strokeColor = type === "worker" ? "#83ACD5" : "#83d59f"
  return (
    <div className="levelProgressBarWrapper" style={style}>
      <div className="levelWrapper">
        <div className="mr-1">
          <LevelTag type={type} screen="working" />
        </div>
        <p className="level">
          <span className="mr-3">Lv.</span>
          <span>{level || 0}</span>
        </p>
      </div>
      <div className="progressWrapper">
        <Progress
          showInfo={false}
          percent={percentToBoostLevel || 0}
          strokeColor={strokeColor}
          size={['default', 20]}
          className="progressBar"
        />
      </div>
    </div>
  )
}

export default LevelProgressBar;